import React, { Component, Fragment } from 'react'
import { Modal, Button, Form, Row, Col, message } from 'antd'
import { NumericInput } from '../../../../components/Parts'
import { api } from '../../../../services'
import className from 'classnames'

class LicensesManager extends Component {
  state = {
    isSubmiting: false,
    modal: false,
    modalId: null,
    error: null,
  }

  componentDidMount () {
    // this.getDivisions()
  }

  getDivisions = () => {
    const { getDivisions } = this.props

    if(getDivisions) {
      getDivisions()
    }
  }

  openModal = (id) => {
    this.setState({
      modal: true,
      modalId: id
    })
  }

  closeModal = () => {
    this.setState({
      error: null,
      modal: false,
      modalId: null
    })
  }

  submitLicensesRequest = (e) => {
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          isSubmiting: true
        })

        api.division.licenseRequests(this.state.modalId, Number(values.licenseNumber))
          .then(response => {
            if (response.data.result) {
              this.setState(state => ({
                error: null
              }))

              message.success(`Request to change number of licenses to ${Number(values.licenseNumber)} is sent.`)

              this.closeModal()
            }

            if (response.data.error) {
              this.setState({
                error: response.data.error.message
              })
            }

            this.setState({
              isSubmiting: false
            })

            this.getDivisions()
          })
      }
    })
  }

  resendLicensesRequest = (id, count) => {
    api.division.licenseRequests(id, count).then(response => {
      if (response.data.result) {
        message.success(`Request to change number of licenses to ${count} is sent.`)
      }
    })
  }

  cancelLicensesRequest = (id) => {
    api.division.cancelLicenseRequests(id).then(response => {
      if (response.data.result) {
        this.getDivisions()
      }
    })
  }

  render () {
    const { isSubmiting, modal, error } = this.state
    const { form: { getFieldDecorator }, division } = this.props
    const divisions = division.list

    return (
      <Fragment>
        { divisions.map(division => {
          const licensesOut = division.usedLicenseNumber >= division.licenseNumber

          return (
          <div className='b-licenses' key={division.id}>
            { licensesOut
              ? <div className='b-licenses__item'>
                  <div className={className({'b-licenses__divisionName': true, 'b-licenses__divisionName_inactive': !division.active, 'b-licenses__divisionName_active': division.active, })}>{division.name}</div>
                  <div className='b-licenses__content'>
                    <div className='b-licenses__message b-licenses__message_out' style={{ marginRight: '1rem' }}>{ division.usedLicenseNumber } out of {division.licenseNumber} licenses used.</div>
                    <div className='b-licenses__message'>You run out of licenses and can’t create new users.<div className='b-licenses__link' style={{ marginLeft: '1rem' }} onClick={() => this.openModal(division.id)}>Request licenses increase</div></div>
                    { division.requestedLicenseNumber && <div className='b-licenses__request'>Request to change number of licenses to { division.requestedLicenseNumber } is sent. <div className='b-licenses__request-link b-licenses__request-link_resend' onClick={() => this.resendLicensesRequest(division.id, division.requestedLicenseNumber)}>Resend</div><div className='b-licenses__request-link b-licenses__request-link_cancel' onClick={() => this.cancelLicensesRequest(division.id)}>Cancel</div> </div> }
                  </div>
                </div>
              : <div className='b-licenses__item'>
                  <div className={className({'b-licenses__divisionName': true, 'b-licenses__divisionName_inactive': !division.active, 'b-licenses__divisionName_active': division.active, })}>{division.name}</div>
                  <div className='b-licenses__content'>
                    <div className='b-licenses__message' style={{ marginRight: '1rem' }}>{ division.usedLicenseNumber } out of {division.licenseNumber} licenses used.</div>
                    <div className='b-licenses__message'><div className='b-licenses__link' onClick={() => this.openModal(division.id)}>Manage licenses</div></div>
                    { division.requestedLicenseNumber && <div className='b-licenses__request'>Request to change number of licenses to { division.requestedLicenseNumber } is sent. <div className='b-licenses__request-link b-licenses__request-link_resend' onClick={() => this.resendLicensesRequest(division.id, division.requestedLicenseNumber)}>Resend</div><div className='b-licenses__request-link b-licenses__request-link_cancel' onClick={() => this.cancelLicensesRequest(division.id)}>Cancel</div> </div> }
                  </div>
                </div>
            }
          </div>
        )}) }

        <Modal
          visible={modal}
          title={'Request to change number of licenses'}
          wrapClassName='vertical-center-modal'
          width={440}
          destroyOnClose
          onCancel={this.closeModal}
          footer={[
            <Button key='submit' type='indigo' loading={isSubmiting} onClick={this.submitLicensesRequest}>Submit</Button>
          ]}
        >
          { error && <div className='form__error'>{ error }</div>}
          <Form onSubmit={this.submitLicensesRequest}>
            <Row>
              <Col span={12}>
                <div className='ant-form-item-label'>
                  <label className='ant-form-item' title='Number of licenses'>Number of licenses</label>
                </div>
              </Col>
              <Col span={12}>
                <Form.Item>
                  {getFieldDecorator('licenseNumber', {
                    rules: [{
                      required: true,
                      message: 'Please input number of licenses',
                      max: 10
                    }]
                  })(
                    <NumericInput name='licenseNumber' maxLength={10} />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Fragment>
    )
  }
}

export default Form.create()(LicensesManager)



// WEBPACK FOOTER //
// ./src/views/Users/components/LicensesManager/LicensesManager.jsx